import { I18n } from '@app/i18n/strings-keys';
import {
  FieldList,
  IFormGroupRules,
  IFormRules,
} from '@components/form/services';
import { EPlacement, WIDGET_COMPONENT } from '@shared/types';
import { assign, get, keys } from 'lodash';
import { HawkerProfileEditContainerComponent } from '@containers/hawker-profile/containers';
import { HawkerProfileFormService } from '@shared/services/hawker-profile/hawker-profile.form.service';
import { WIDGET_FAMILY } from '@config/global-constants';

export const createFormRules = (
  formService: HawkerProfileFormService,
  editor: HawkerProfileEditContainerComponent,
): IFormRules => {
  const employeeId = get(editor, '_id');

  const sections: FieldList = {
    general_section: {
      widget: WIDGET_COMPONENT.panel_group,
      title: I18n.Common.General,
    },
    commission_rate_assignment_section: {
      widget: WIDGET_COMPONENT.panel_group,
      class: 'commission-rate-no-padding',
    },
  };

  const generationSectionFields: FieldList = {
    'virtual.firstName': {
      title: I18n.Forms.GridForm.FirstName,
      disabled: true,
    },
    'virtual.lastName': {
      title: I18n.Forms.GridForm.LastName,
      disabled: true,
    },
    'virtual.badgeNumber': {
      title: I18n.Forms.GridForm.BadgeNumber,
      disabled: true,
    },
    'virtual.employeeCorporateCode': {
      title: I18n.Forms.HawkerProfileForm.EmployeeCorporateCode,
      disabled: true,
    },
    'virtual.formattedSites': {
      title: I18n.EntityNames.Site,
      disabled: true,
      widget: WIDGET_COMPONENT.multiple_selection_list,
      class: 'site-multi-selection-list',
      widgetData: {
        placement: EPlacement.topRight,
      },
    },
  };

  const panelGroups: IFormGroupRules[] = [
    {
      name: I18n.Common.General,
      fields: ['general_section', 'commission_rate_assignment_section'],
    },
    {
      id: 'general_section',
      fields: keys(generationSectionFields),
    },
    {
      id: 'commission_rate_assignment_section',
      fields: ['commission_rates'],
    },
  ];

  const generationVirtualFields = keys(generationSectionFields).reduce(
    (acc, k) =>
      assign(acc, { [k.replace('virtual.', '')]: { type: 'string' } }),
    {},
  );

  return {
    fields: {
      ...sections,
      ...generationSectionFields,
      commission_rates: {
        title: I18n.Forms.HawkerProfileForm.CommissionRateAssignment,
        ignoreAutoTitleWhenTranslate: true,
        class: 'commission-rate-grid',
        widgetFamily: WIDGET_FAMILY.XUX,
        widget: WIDGET_COMPONENT.commission_rate_assignment_grid,
        widgetData: {
          employee_id: employeeId,
          handleAssignmentGridSaveObs: editor.saveObs$,
        },
      },
    },
    groups: [...panelGroups],
    defaultGroup: false,
    virtual: {
      type: 'object',
      properties: {
        ...generationVirtualFields,
      },
    },
  };
};
